import { render, staticRenderFns } from "./TabellaPrezzi.vue?vue&type=template&id=e0350c7a&scoped=true&"
import script from "./TabellaPrezzi.vue?vue&type=script&lang=js&"
export * from "./TabellaPrezzi.vue?vue&type=script&lang=js&"
import style0 from "./TabellaPrezzi.vue?vue&type=style&index=0&id=e0350c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0350c7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0350c7a')) {
      api.createRecord('e0350c7a', component.options)
    } else {
      api.reload('e0350c7a', component.options)
    }
    module.hot.accept("./TabellaPrezzi.vue?vue&type=template&id=e0350c7a&scoped=true&", function () {
      api.rerender('e0350c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/TabellaPrezzi.vue"
export default component.exports